



























	import Vue from 'vue';
    import ErfolgComponent from "./ErfolgComponent.vue";
    import _icons from '../../services/icons';

    export default Vue.extend({
        name: "ErfolgWingComponent",
        components: {ErfolgComponent},
        props: ['allDone', 'wing'],
        data: () => ({
            done: 0,
            show: false
        }),
        computed: {
            wingIcon: function(): string {
                return _icons.wingIcon(this.wing.wing);
            },
            totalAchievements: function(): number {
                return this.wing.achievements.length;
            },
            complete: function(): boolean {
                return this.done === this.totalAchievements;
            },
            textClass: function(): string {
                return `doneCount ${this.complete? 'success--text': ''}`
            },
            dropdownIcon: function(): string {
                return this.show ? 'keyboard_arrow_up' : 'keyboard_arrow_down';
            }
        },
        methods: {
            countDone: function(): void {
                this.done++;
            },
            toggleShow: function(): void {
                this.show = !this.show;
            }
        }
    })
